import React from "react";
import type { ReactNode } from "react";

import { Button, Content } from "./styles";

export type Props = {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
  url: string;
};

export const PrintButton: React.FunctionComponent<Props> = ({
  children,
  className,
  onClick,
  url,
}) => {
  const handleClick = () => {
    window.open(`/print${url}`, "_blank");
    onClick?.();
  };

  return (
    <Button aria-label="print" className={className} onClick={handleClick} type="button">
      <Content>{children}</Content>
    </Button>
  );
};

PrintButton.displayName = "PrintButton";
